<template>
  <div class="admin-festivos">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div>
        <h4 class="mb-0">Festivos del Calendario</h4>
        <small class="text-muted">{{ calendario ? calendario.nombre : '' }}</small>
      </div>
      <div>
        <b-button variant="outline-secondary" size="sm" class="mr-1" @click="$emit('volver')">
          <feather-icon icon="ArrowLeftIcon" class="mr-50" />
          Volver
        </b-button>
        <b-button variant="primary" size="sm" @click="abrirModalNuevo">
          <feather-icon icon="PlusIcon" class="mr-50" />
          Añadir Festivo
        </b-button>
      </div>
    </div>

    <b-table
      :items="festivosCalendario"
      :fields="campos"
      responsive
      show-empty
      empty-text="No hay festivos"
    >
      <template #cell(fecha)="data">
        {{ formatearFecha(data.item.fecha) }}
      </template>

      <template #cell(acciones)="data">
        <b-button variant="flat-danger" size="sm" @click="eliminar(data.item.id)">
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>

    <!-- Modal Añadir Festivo -->
    <b-modal
      v-model="mostrarModal"
      title="Añadir Festivo"
      ok-title="Guardar"
      cancel-title="Cancelar"
      centered
      @ok="guardar"
    >
      <b-form-group label="Fecha" label-for="fecha">
        <b-form-input v-model="formulario.fecha" type="date" />
      </b-form-group>

      <b-form-group label="Nombre del festivo" label-for="nombre">
        <b-form-input v-model="formulario.nombre" placeholder="Ej: Navidad" />
      </b-form-group>

      <hr>

      <h6>Festivos comunes (España)</h6>
      <div class="d-flex flex-wrap">
        <b-button
          v-for="festivo in festivosComunes"
          :key="festivo.nombre"
          variant="outline-primary"
          size="sm"
          class="mr-50 mb-50"
          @click="aplicarFestivoComun(festivo)"
        >
          {{ festivo.nombre }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BTable, BButton, BModal, BFormGroup, BFormInput } from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BTable,
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
  },

  props: {
    calendario: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      mostrarModal: false,
      formulario: {
        fecha: '',
        nombre: '',
      },
      campos: [
        { key: 'fecha', label: 'Fecha', sortable: true },
        { key: 'nombre', label: 'Festivo' },
        { key: 'acciones', label: '' },
      ],
    }
  },

  computed: {
    ...mapState('vacaciones', ['festivosCalendario']),

    calendarioId() {
      return this.calendario ? this.calendario.id : null
    },

    festivosComunes() {
      const anio = (this.calendario && this.calendario.anio) || new Date().getFullYear()
      return [
        { nombre: 'Año Nuevo', fecha: `${anio}-01-01` },
        { nombre: 'Reyes', fecha: `${anio}-01-06` },
        { nombre: 'Dia del Trabajo', fecha: `${anio}-05-01` },
        { nombre: 'Asuncion', fecha: `${anio}-08-15` },
        { nombre: 'Fiesta Nacional', fecha: `${anio}-10-12` },
        { nombre: 'Todos los Santos', fecha: `${anio}-11-01` },
        { nombre: 'Constitucion', fecha: `${anio}-12-06` },
        { nombre: 'Inmaculada', fecha: `${anio}-12-08` },
        { nombre: 'Navidad', fecha: `${anio}-12-25` },
      ]
    },
  },

  watch: {
    calendario: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fetchFestivos(val.id)
        }
      },
    },
  },

  methods: {
    ...mapActions('vacaciones', ['fetchFestivos', 'crearFestivo', 'eliminarFestivo']),

    abrirModalNuevo() {
      this.formulario = { fecha: '', nombre: '' }
      this.mostrarModal = true
    },

    aplicarFestivoComun(festivo) {
      this.formulario.fecha = festivo.fecha
      this.formulario.nombre = festivo.nombre
    },

    async guardar(bvModalEvt) {
      bvModalEvt.preventDefault()

      if (!this.formulario.fecha || !this.formulario.nombre) {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Fecha y nombre son requeridos', icon: 'AlertTriangleIcon', variant: 'warning' },
        })
        return
      }

      try {
        await this.crearFestivo({
          calendario_id: this.calendarioId,
          ...this.formulario,
        })
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Festivo añadido', icon: 'CheckIcon', variant: 'success' },
        })
        this.mostrarModal = false
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: { title: error.error || 'Error al guardar', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      }
    },

    async eliminar(id) {
      try {
        await this.eliminarFestivo({ id, calendario_id: this.calendarioId })
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Festivo eliminado', icon: 'CheckIcon', variant: 'success' },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: { title: error.error || 'Error al eliminar', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      }
    },

    formatearFecha(fecha) {
      return new Date(fecha).toLocaleDateString('es-ES', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
      })
    },
  },
}
</script>
